export interface CloudPlan {
  name: string;
  price: string;
  storage: string;
  description: string;
  features: string[];
  highlighted: boolean;
}

export const cloudPlans: CloudPlan[] = [
  {
    name: 'Gratuit',
    price: '0 FCFA',
    storage: '5 Go',
    description: 'Pour démarrer et découvrir le Cloud en toute simplicité.',
    features: [
      '5 Go de stockage',
      'Adresse email @worldapeiron.com',
      'Partage par lien public',
      'Accès depuis tous vos appareils',
    ],
    highlighted: false,
  },
  {
    name: 'Standard',
    price: '2 000 FCFA/mois',
    storage: '50 Go',
    description: 'Pour les indépendants et créateurs actifs.',
    features: [
      '50 Go de stockage',
      'Adresse email @worldapeiron.com',
      'Dossiers illimités',
      'Partage sécurisé avec mot de passe',
      'Historique & corbeille',
    ],
    highlighted: true,
  },
  {
    name: 'Premium',
    price: '5 000 FCFA/mois',
    storage: '200 Go',
    description: 'Pour les équipes et les gros volumes de fichiers.',
    features: [
      '200 Go de stockage',
      'Adresse email @worldapeiron.com',
      'Partage multi-utilisateurs',
      'Synchronisation automatique',
      'Priorité de support',
    ],
    highlighted: false,
  },
  {
    name: 'Business',
    price: '15 000 FCFA/mois',
    storage: '1 To',
    description: 'Pour les entreprises avec des besoins intensifs.',
    features: [
      '1 To de stockage',
      'Plusieurs adresses email @worldapeiron.com',
      'Permissions avancées',
      'Antivirus & chiffrement',
      'SLA et support dédié',
    ],
    highlighted: false,
  },
];